import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useProductStore } from '@/stores/ProductStore';
import { useApiForecastModels } from '@/composables/useApiForecastModels';

export let useForecastModelStore = defineStore('forecastModelStore', () => {
    const productStore = useProductStore();
    const apiForecastModels = useApiForecastModels();

    let models = ref([]);
    let selectedModel = ref(null);
    let selectedModelId = ref(null);
    let selectedModelName = ref('');
    let selectedModelShortName = ref('');
    let selectedModelDisplayName = ref('');
    let selectedModelRuns = ref(null);
    let selectedModelRun = ref(null);
    let selectedModelRunName = ref('');
    let selectedModelRunTime = ref(null);
    let hasPremiumUpgrade = ref(false);

    async function getForecastModels(modelId, bounds) {
      if (!bounds) {
        console.warn('No bounds provided to getForecastModels');
        return;
      }

      const { error, data } = await apiForecastModels.byArea(bounds);

      models.value = Object.hasOwnProperty.call(data.value, 'model_summary_all_runs') ? data.value.model_summary_all_runs : data.value.model_summary;

      setSelectedModel({ modelId })

      return { selectedModel: selectedModel.value, models: models.value }
    }

    // Ocean Currents (not current time)
    async function getCurrentModels() {
      const { availableCurrentModels } = await productStore.getRegionalProducts(true);

      if (!availableCurrentModels) {
        selectedModel.value = null;
        models.value = [];
      } else {
        models.value = availableCurrentModels;
        setSelectedModel({ currents: true });
      }

      return { selectedModel: selectedModel.value, models: models.value }
    }

    function setSelectedModel(settings) {
      const defaultSettings = { modelId: null, currents: false, defaultModelType: 'all' }
      const { modelId, currents, defaultModelType } = Object.assign({}, defaultSettings, settings)

      const defaultModel = models.value[0];
      let freeDefaultModel;
      let premiumDefaultModel;
      let selectedModelAvailable = false;
      let selectedFxModelId = modelId || selectedModelId.value
      let selectedFxModel;

      models.value.forEach((model) => {
        // Adding this here since the models are already being looped through
        if (model.upgrade_available) {
          hasPremiumUpgrade.value = true
        }

        if (!freeDefaultModel && !model.upgrade_available && !model.is_premium) {
          freeDefaultModel = model
        }

        if (!premiumDefaultModel && !model.upgrade_available && model.is_premium) {
          premiumDefaultModel = model
        }

        if (selectedFxModelId && model.model_id === selectedFxModelId) {
          selectedFxModel = model;
          selectedModelAvailable = true;
        }
      })

      if (!selectedFxModelId || !selectedModelAvailable) {
        selectedFxModel =
          defaultModelType === 'all'
            ? defaultModel
            : premiumDefaultModel
              ? premiumDefaultModel
              : freeDefaultModel

        selectedFxModelId = selectedFxModel.model_id;
      }

      selectedModel.value = selectedFxModel;
      selectedModelId.value = selectedFxModelId;
      selectedModelName.value = selectedFxModel?.model_name;
      selectedModelShortName.value = selectedFxModel?.model_short_name;
      selectedModelDisplayName.value = currents
        ? selectedFxModel.model_name
        : selectedFxModel.model_short_name;
      selectedModelRuns.value = selectedFxModel?.model_runs || null;

      setSelectedModelRun();
    }

    function setSelectedModelRun(modelRunId) {
      if (!selectedModelRuns.value) return;

      if (!modelRunId) {
        selectedModelRun.value = selectedModelRuns.value[0];
        selectedModelRunName.value = !selectedModelRuns.value[0].model_run_name ? '' : selectedModelRuns.value[0].model_run_name;
        selectedModelRunTime.value = selectedModelRuns.value[0].start_time_utc;

        return;
      }

      selectedModelRun.value = selectedModelRuns.value.find(modelRun => modelRun.model_run_id === modelRunId);

      if (!selectedModelRun.value) return;

        // selectedModelRun.value = selectedModelRun.value;
        selectedModelRunTime.value = selectedModelRun.value.model_run_time_utc
        selectedModelRunName.value = selectedModelRun.value.model_run_name
          ? selectedModelRun.value.model_run_name
          : '';
    }

    return {
      models,
      selectedModel,
      selectedModelId,
      selectedModelName,
      selectedModelShortName,
      selectedModelDisplayName,
      selectedModelRuns,
      selectedModelRun,
      selectedModelRunName,
      selectedModelRunTime,
      hasPremiumUpgrade,
      getForecastModels,
      getCurrentModels,
      setSelectedModel,
      setSelectedModelRun
    }
});
